(function () {
  function initExtras(root) {
    var items = root.querySelectorAll('[data-fw-dept-extra-item]');
    var layout = root.querySelector('.fw-dept-extras__layout');
    if (!items.length) return;

    function setActive(index) {
      items.forEach(function (item, i) {
        var active = i === index;
        item.classList.toggle('is-active', active);
        var btn = item.querySelector('.fw-dept-extras__trigger');
        var polaroid = item.querySelector('[data-fw-dept-extra-preview]');
        if (btn) btn.setAttribute('aria-expanded', active ? 'true' : 'false');
        if (polaroid) polaroid.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    items.forEach(function (item, index) {
      var btn = item.querySelector('.fw-dept-extras__trigger');
      if (!btn) return;

      item.addEventListener('mouseenter', function () {
        setActive(index);
      });

      btn.addEventListener('focus', function () {
        setActive(index);
      });

      btn.addEventListener('click', function () {
        setActive(index);
      });
    });

    if (layout) {
      layout.addEventListener('mouseleave', function () {
        setActive(-1);
      });
    }

    setActive(-1);
  }

  function initCuisinesScroll(scroller) {
    if (!scroller || scroller.dataset.fwCuisinesDragInit === 'true') return;
    scroller.dataset.fwCuisinesDragInit = 'true';

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isDragging = false;
    var startX = 0;
    var startScrollLeft = 0;
    var moved = false;
    var dragThreshold = 4;
    var lastMoveX = 0;
    var lastMoveTime = 0;
    var velocity = 0;
    var dragScrollLeft = 0;
    var dragRaf = 0;
    var coastRaf = 0;
    var maxScroll = 0;

    function updateMaxScroll() {
      var track = scroller.querySelector('.fw-dept-cuisines__track');
      var lastCard = null;

      if (track) {
        var cards = track.children;
        for (var i = cards.length - 1; i >= 0; i -= 1) {
          if (getComputedStyle(cards[i]).display !== 'none') {
            lastCard = cards[i];
            break;
          }
        }
      }

      if (lastCard) {
        var styles = getComputedStyle(scroller);
        var padEnd = parseFloat(styles.paddingInlineEnd || styles.paddingRight) || 0;
        var end = lastCard.offsetLeft + lastCard.offsetWidth;
        maxScroll = Math.max(0, end - scroller.clientWidth + padEnd);
      } else {
        maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      }

      if (scroller.scrollLeft > maxScroll) {
        scroller.scrollLeft = maxScroll;
      }
    }

    function clampScroll(value) {
      return Math.max(0, Math.min(maxScroll, value));
    }

    function cancelCoast() {
      if (coastRaf) {
        cancelAnimationFrame(coastRaf);
        coastRaf = 0;
      }
      scroller.classList.remove('is-coasting');
    }

    function flushDragScroll() {
      dragRaf = 0;
      scroller.scrollLeft = dragScrollLeft;
    }

    function scheduleDragScroll(nextLeft) {
      dragScrollLeft = clampScroll(nextLeft);
      if (!dragRaf) {
        dragRaf = requestAnimationFrame(flushDragScroll);
      }
    }

    function runCoast(initialVelocity) {
      if (prefersReducedMotion || Math.abs(initialVelocity) < 0.03) return;

      cancelCoast();
      scroller.classList.add('is-coasting');
      updateMaxScroll();

      var v = initialVelocity * 1.1;
      var decay = 0.962;
      var lastTs = performance.now();

      function step(now) {
        var dt = Math.min(32, now - lastTs);
        lastTs = now;

        if (Math.abs(v) < 0.02) {
          coastRaf = 0;
          scroller.classList.remove('is-coasting');
          return;
        }

        var next = clampScroll(scroller.scrollLeft - v * dt);
        scroller.scrollLeft = next;
        v *= Math.pow(decay, dt / 16.67);

        if (next <= 0 || next >= maxScroll) {
          coastRaf = 0;
          scroller.classList.remove('is-coasting');
          return;
        }

        coastRaf = requestAnimationFrame(step);
      }

      coastRaf = requestAnimationFrame(step);
    }

    scroller.addEventListener(
      'dragstart',
      function (event) {
        event.preventDefault();
      },
      true
    );

    scroller.addEventListener(
      'click',
      function (event) {
        if (scroller.dataset.fwDragClickBlock === 'true') {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      true
    );

    scroller.addEventListener('pointerdown', function (event) {
      if (event.button !== 0) return;
      if (event.pointerType === 'touch') return;
      if (event.target.closest('.fw-dept-cuisines__cta')) return;

      cancelCoast();
      updateMaxScroll();
      isDragging = true;
      moved = false;
      velocity = 0;
      startX = event.clientX;
      lastMoveX = event.clientX;
      lastMoveTime = performance.now();
      startScrollLeft = scroller.scrollLeft;
      scroller.classList.add('is-dragging');
      scroller.dataset.fwDragClickBlock = 'false';

      event.preventDefault();

      if (scroller.setPointerCapture) {
        scroller.setPointerCapture(event.pointerId);
      }
    });

    scroller.addEventListener('pointermove', function (event) {
      if (!isDragging) return;

      var now = performance.now();
      var deltaX = event.clientX - startX;

      if (Math.abs(deltaX) > dragThreshold) {
        moved = true;
      }

      var dt = now - lastMoveTime;
      if (dt > 0) {
        var instantV = (event.clientX - lastMoveX) / dt;
        velocity = velocity * 0.6 + instantV * 0.4;
      }

      lastMoveX = event.clientX;
      lastMoveTime = now;
      scheduleDragScroll(startScrollLeft - deltaX);
    });

    function endDrag(event) {
      if (!isDragging) return;

      isDragging = false;
      scroller.classList.remove('is-dragging');

      if (dragRaf) {
        cancelAnimationFrame(dragRaf);
        dragRaf = 0;
        flushDragScroll();
      }

      if (scroller.releasePointerCapture) {
        try {
          scroller.releasePointerCapture(event.pointerId);
        } catch (err) {
          /* pointer already released */
        }
      }

      if (moved) {
        scroller.dataset.fwDragClickBlock = 'true';
        window.setTimeout(function () {
          scroller.dataset.fwDragClickBlock = 'false';
        }, 80);
        runCoast(velocity);
      }
    }

    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);

    updateMaxScroll();
    window.addEventListener('resize', updateMaxScroll, { passive: true });
    scroller.addEventListener(
      'scroll',
      function () {
        updateMaxScroll();
      },
      { passive: true }
    );
  }

  function initSmoothAnchors() {
    document.querySelectorAll('a[href="#fw-store-directory"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.getElementById('fw-store-directory');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-fw-dept-extras]').forEach(initExtras);
    document.querySelectorAll('[data-fw-dept-cuisines-scroll]').forEach(initCuisinesScroll);
    initSmoothAnchors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
